import { render, staticRenderFns } from "./ReportInvoiceAnalyticsGeneral.vue?vue&type=template&id=2d06e051&scoped=true"
import script from "./ReportInvoiceAnalyticsGeneral.vue?vue&type=script&lang=js"
export * from "./ReportInvoiceAnalyticsGeneral.vue?vue&type=script&lang=js"
import style0 from "./ReportInvoiceAnalyticsGeneral.vue?vue&type=style&index=0&id=2d06e051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06e051",
  null
  
)

export default component.exports